import { Award, Code2, Cpu, Trophy } from 'lucide-react';
import { SectionTitle, FadeIn } from '@/components/common/SectionTitle';

const ITEMS = [
  { icon: Cpu, label: 'AI-First Curriculum', desc: 'Self-healing locators, AI test gen, prompt-engineered automation flows.' },
  { icon: Code2, label: 'Real-Time Projects', desc: 'Banking, fintech & e-commerce capstone projects, not theory.' },
  { icon: Award, label: 'Industry Mentor', desc: '18+ years architect-level mentorship by Rahul Ganjare.' },
  { icon: Trophy, label: 'Career Outcomes', desc: 'Avg 60-80% hike, mock interviews, referrals & resume rebuild.' },
];

const WhyBymat = () => {
  return (
    <section className="relative py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionTitle
          label="Why BYMAT"
          title={<span className="font-semibold">Built for serious career transformation.</span>}
          subtitle="Not another course catalog. A high-touch mentorship system engineered for outcomes."
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {ITEMS.map((it, i) => (
            <FadeIn key={it.label} delay={i * 0.08}>
              <div className="h-full glass rounded-2xl p-6 hover:border-brand-cyan/40 transition">
                <div className="h-11 w-11 rounded-lg bg-brand-cyan/10 text-brand-cyan flex items-center justify-center border border-brand-cyan/20">
                  <it.icon className="w-5 h-5" />
                </div>
                <h3 className="mt-5 font-display font-bold text-lg">{it.label}</h3>
                <p className="mt-2 text-sm text-white/65 leading-relaxed">{it.desc}</p>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyBymat;
